import { AnalyticBaseProperties } from './analytic-base-properties.model';
export class AnalyticPilotPopupPageLoadedProperties extends AnalyticBaseProperties {
  PageName: string;
  PopupPageName: string;

  constructor(pageName: string, popupPageName: string) {
    super();
    this.PageName = pageName;
    this.PopupPageName = popupPageName;
  }

  override parse(): any {
    const fromSuper = super.parse();
    fromSuper.page_name = this.PageName;
    fromSuper.popup_page_name = this.PopupPageName;
    return fromSuper
  }
}
